import { ITouchScreenCommentObserverProps } from "interfaces";
import useIntersect from "../../../../../helpers/hooks/useIntersect";
import store from "../../../../../redux/store";

const TouchScreenCommentObserver = ({ setScrollEnd }: ITouchScreenCommentObserverProps) => {
    const handleIntersect = ([entry]: IntersectionObserverEntry[]) => {
        const { comments, commentsCountPagination } = store.getState().comments;
        if (entry.isIntersecting && (comments === undefined || comments.length !== commentsCountPagination)) setScrollEnd(true);
    };
    const observerRef = useIntersect(handleIntersect);

    return <div id="observer" className="pl-bg-transparent pl-pt-5" ref={observerRef} />;
};

export default TouchScreenCommentObserver;
